export const Nationality = [
    'Afghanistan',
    'Albania',
    'Algeria',
    'Antigua and Barbuda',
    'Argentina',
    'Armenia',
    'Aruba',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahrain',
    'Bangladesh',
    'Belarus',
    'Belgium',
    'Bosnia and Herzegovina',
    'Brazil',
    'Brunei Darussalam',
    'Bulgaria',
    'Burundi',
    'Cameroon',
    'Canada',
    'Chile',
    'China',
    'Colombia',
    'Croatia',
    'Cuba',
    'Cyprus',
    'Czech Republic',
    "Côte d'Ivoire",
    'Denmark',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'Egypt',
    'Eritrea',
    'Estonia',
    'Ethiopia',
    'Fiji',
    'Finland',
    'France',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Gibraltar',
    'Greece',
    'Grenada',
    'Guinea',
    'Hong Kong Special Administrative Region of China',
    'Hungary',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Ireland',
    'Israel',
    'Italy',
    'Japan',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'South Korea',
    'Kosovo',
    'Kuwait',
    'Kyrgyzstan',
    'Latvia',
    'Lebanon',
    'Lithuania',
    'Macedonia Republic of',
    'Malawi',
    'Malaysia',
    'Malta',
    'Mauritius',
    'Mexico',
    'Moldova',
    'Montenegro',
    'Morocco',
    'Nepal',
    'Netherlands',
    'New Zealand',
    'Niger',
    'Nigeria',
    'Norway',
    'Oman',
    'Pakistan',
    'Palestine',
    'Panama',
    'Peru',
    'Philippines',
    'Poland',
    'Portugal',
    'Puerto Rico',
    'Romania',
    'Russian Federation',
    'Saint Kitts and Nevis',
    'Saudi',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'Somalia',
    'South Africa',
    'Spain',
    'Sri Lanka',
    'Sudan',
    'Sweden',
    'Switzerland',
    'Syria',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    'Trinidad and Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Uganda',
    'Ukraine',
    'UAE',
    'United Kingdom',
    'United States Minor Outlying Islands',
    'United States of America',
    'Uzbekistan',
    'Venezuela',
    'Yemen',
    'Zambia',
    'Zimbabwe',
  ];